import { ICommonIconProps } from './types';

/**
 * -----------------------------------------------------------------------------
 * It shows a pen icon with the notes to indicate edit action
 */
export function PenEditIcon({ className }: Readonly<ICommonIconProps>) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24">
      <path
        className="stroke-gray-500"
        d="M21 10.713v8.276C21 20.1 20.129 21 19.054 21H4.946C3.871 21 3 20.1 3 18.99V7.01C3 5.9 3.871 5 4.946 5h5.351"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.484}
      />
      <path
        className="stroke-gray-500"
        clipRule="evenodd"
        d="M18.062 3.505a1.72 1.72 0 0 1 2.434 0v0a1.72 1.72 0 0 1-.001 2.434l-5.774 5.77a.998.998 0 0 1-.706.291H12V9.985a1 1 0 0 1 .293-.707l5.769-5.773v0Z"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path
        className="stroke-gray-500"
        d="M8 12H6M6 16h12M19.43 7 17 4.57"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
    </svg>
  );
}
